// import React, { useEffect, useState } from "react";
// import "./PermissionManager.css";

// const actions = [
//   "add",
//   "edit",
//   "view",
//   "refresh",
//   "save",
//   "approve",
//   "print",
//   "exit"
// ];

// export default function PermissionManager(){

// const [employees,setEmployees] = useState([]);
// const [modules,setModules] = useState([]);
// const [screens,setScreens] = useState([]);
// const [selectedEmployee,setSelectedEmployee] = useState("");
// const [selectedModules,setSelectedModules] = useState([]);
// const [permissions,setPermissions] = useState({});

// useEffect(()=>{
//  loadEmployees();
//  loadModules();
//  loadScreens();
// },[]);

// const loadEmployees = async ()=>{

//  const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/employees");
//  const data = await res.json();

//  if(data.success){
//   setEmployees(data.data);
//  }

// };


// const loadModules = async ()=>{

//  const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/modules");
//  const data = await res.json();

//  if(data.success){
//   setModules(data.data);
//  }

// };


// const loadScreens = async ()=>{

//  const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/screens");
//  const data = await res.json();

//  if(data.success){

//   const formatted = data.data.map(s=>({
//    id:s.id,
//    module:s.module_name,
//    type:s.screen_type,
//    name:s.screen_name
//   }));

//   setScreens(formatted);

//  }

// };


// useEffect(()=>{

//  if(!selectedEmployee) return;

//  setPermissions({}); // reset old state
//  fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/permissions/${selectedEmployee}`)
//  .then(res=>res.json())
//  .then(data=>{

//   if(data.success){

//    const perms = {};

//    data.data.forEach(p=>{

//     perms[`${p.screen_id}_add`] = p.can_add;
//     perms[`${p.screen_id}_edit`] = p.can_edit;
//     perms[`${p.screen_id}_view`] = p.can_view;
//     perms[`${p.screen_id}_refresh`] = p.can_refresh;
//     perms[`${p.screen_id}_save`] = p.can_save;
//     perms[`${p.screen_id}_approve`] = p.can_approve;
//     perms[`${p.screen_id}_print`] = p.can_print;
//     perms[`${p.screen_id}_exit`] = p.can_exit;

//    });

//    setPermissions(perms);

//   }

//  });

// },[selectedEmployee]);




// const handleModuleSelect = (e)=>{

//  const value = e.target.value;

//  if(selectedModules.includes(value)){
//   setSelectedModules(selectedModules.filter(m=>m!==value));
//  }else{
//   setSelectedModules([...selectedModules,value]);
//  }

// };

// const togglePermission = (screenId,action)=>{

//  const key = `${screenId}_${action}`;

//  setPermissions({
//   ...permissions,
//   [key]:!permissions[key]
//  });

// };

// const savePermissions = async ()=>{

//  const payload = [];

//  screens
//  .filter(screen => selectedModules.includes(screen.module))
//  .forEach(screen=>{

//     const record = {
//   screen_id:screen.id,
//   can_add:permissions[`${screen.id}_add`] ? 1 : 0,
//   can_edit:permissions[`${screen.id}_edit`] ? 1 : 0,
//   can_view:permissions[`${screen.id}_view`] ? 1 : 0,
//   can_refresh:permissions[`${screen.id}_refresh`] ? 1 : 0,
//   can_save:permissions[`${screen.id}_save`] ? 1 : 0,
//   can_approve:permissions[`${screen.id}_approve`] ? 1 : 0,
//   can_print:permissions[`${screen.id}_print`] ? 1 : 0,
//   can_exit:permissions[`${screen.id}_exit`] ? 1 : 0
// };

// const permissionValues = [
//   record.can_add,
//   record.can_edit,
//   record.can_view,
//   record.can_refresh,
//   record.can_save,
//   record.can_approve,
//   record.can_print,
//   record.can_exit
// ];

// if(permissionValues.some(v => v === 1)){
//   payload.push(record);
// }

//  });

//  await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/permissions/save",{
//   method:"POST",
//   headers:{ "Content-Type":"application/json" },
//   body:JSON.stringify({
//    employee_id:selectedEmployee,
//    permissions:payload
//   })
//  });

//  alert("Permissions Saved");

// };

// const filteredScreens = screens.filter(screen =>
//  selectedModules.includes(screen.module)
// );

// const grouped = {};

// filteredScreens.forEach(screen=>{

//  if(!grouped[screen.module]) grouped[screen.module] = {};

//  if(!grouped[screen.module][screen.type]) grouped[screen.module][screen.type] = [];

//  grouped[screen.module][screen.type].push(screen);

// });

// return(

// <div className="permission-container">

// <div className="permission-header">

// <h2>Employee Permission Management</h2>

// <div className="filters">

// <label>Employee</label>

// <select
// value={selectedEmployee}
// onChange={(e)=>setSelectedEmployee(e.target.value)}
// >
// <option value="">Select Employee</option>

// {employees.map(emp=>(
// <option key={emp.id} value={emp.id}>
// {emp.name}
// </option>
// ))}

// </select>

// </div>

// </div>

// <div className="module-select">

// <h3>Select Modules</h3>

// {modules.map(mod=>(
// <label key={mod.id} className="module-checkbox">

// <input
// type="checkbox"
// value={mod.module_name}
// checked={selectedModules.includes(mod.module_name)}
// onChange={handleModuleSelect}
// />

// {mod.module_name}

// </label>
// ))}

// </div>

// <div className="permission-table">

// <table>

// <thead>

// <tr>

// <th>Screen</th>

// {actions.map(action=>(
// <th key={action}>{action.toUpperCase()}</th>
// ))}

// </tr>

// </thead>

// <tbody>

// {Object.keys(grouped).map(module=>(

// <React.Fragment key={module}>

// <tr className="module-row">
// <td colSpan="9">{module}</td>
// </tr>

// {Object.keys(grouped[module]).map(type=>(

// <React.Fragment key={type}>

// <tr className="type-row">
// <td colSpan="9">{type}</td>
// </tr>

// {grouped[module][type].map(screen=>(

// <tr key={screen.id}>

// <td className="screen-name">
// {screen.name}
// </td>

// {actions.map(action=>{

// const key = `${screen.id}_${action}`;

// return(
// <td key={action}>

// <input
// type="checkbox"
// checked={permissions[key] || false}
// onChange={()=>togglePermission(screen.id,action)}
// />

// </td>
// );

// })}

// </tr>

// ))}

// </React.Fragment>

// ))}

// </React.Fragment>

// ))}

// </tbody>

// </table>

// </div>

// <div className="save-area">

// <button
// className="save-btn"
// onClick={savePermissions}
// >
// Save Permissions
// </button>

// </div>

// </div>

// );

// }


import React, { useEffect, useState } from "react";
import "./PermissionManager.css";

const actions = [
  "add",
  "edit",
  "view",
  "refresh",
  "save",
  "approve",
  "print",
  "exit"
];

export default function PermissionManager(){

const [employees,setEmployees] = useState([]);
const [modules,setModules] = useState([]);
const [screens,setScreens] = useState([]);
const [selectedEmployee,setSelectedEmployee] = useState("");
const [selectedModules,setSelectedModules] = useState([]);
const [permissions,setPermissions] = useState({});

useEffect(()=>{
 loadEmployees();
 loadModules();
 loadScreens();
},[]);

const loadEmployees = async ()=>{

 const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/employees");
 const data = await res.json();

 if(data.success){
  setEmployees(data.data);
 }

};


const loadModules = async ()=>{

 const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/modules");
 const data = await res.json();

 if(data.success){
  setModules(data.data);
 }

};


const loadScreens = async ()=>{

 const res = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/screens");
 const data = await res.json();

 if(data.success){

  const formatted = data.data.map(s=>({
   id:s.id,
   module:s.module_name,
   type:s.screen_type,
   name:s.screen_name
  }));

  setScreens(formatted);

 }

};


useEffect(()=>{

 if(!selectedEmployee) return;

 setPermissions({}); // reset old state
 fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/permissions/${selectedEmployee}`)
 .then(res=>res.json())
 .then(data=>{

  if(data.success){

   const perms = {};

   data.data.forEach(p=>{

    perms[`${p.screen_id}_add`] = p.can_add;
    perms[`${p.screen_id}_edit`] = p.can_edit;
    perms[`${p.screen_id}_view`] = p.can_view;
    perms[`${p.screen_id}_refresh`] = p.can_refresh;
    perms[`${p.screen_id}_save`] = p.can_save;
    perms[`${p.screen_id}_approve`] = p.can_approve;
    perms[`${p.screen_id}_print`] = p.can_print;
    perms[`${p.screen_id}_exit`] = p.can_exit;

   });

   setPermissions(perms);

  }

 });

},[selectedEmployee]);




const handleModuleSelect = (e)=>{

 const value = e.target.value;

 if(selectedModules.includes(value)){
  setSelectedModules(selectedModules.filter(m=>m!==value));
 }else{
  setSelectedModules([...selectedModules,value]);
 }

};

const togglePermission = (screenId,action)=>{

 const key = `${screenId}_${action}`;

 setPermissions({
  ...permissions,
  [key]:!permissions[key]
 });

};

// const savePermissions = async ()=>{

//  const payload = [];

//  screens
//  .filter(screen => selectedModules.includes(screen.module))
//  .forEach(screen=>{

//     const record = {
//   screen_id:screen.id,
//   can_add:permissions[`${screen.id}_add`] ? 1 : 0,
//   can_edit:permissions[`${screen.id}_edit`] ? 1 : 0,
//   can_view:permissions[`${screen.id}_view`] ? 1 : 0,
//   can_refresh:permissions[`${screen.id}_refresh`] ? 1 : 0,
//   can_save:permissions[`${screen.id}_save`] ? 1 : 0,
//   can_approve:permissions[`${screen.id}_approve`] ? 1 : 0,
//   can_print:permissions[`${screen.id}_print`] ? 1 : 0,
//   can_exit:permissions[`${screen.id}_exit`] ? 1 : 0
// };

// const permissionValues = [
//   record.can_add,
//   record.can_edit,
//   record.can_view,
//   record.can_refresh,
//   record.can_save,
//   record.can_approve,
//   record.can_print,
//   record.can_exit
// ];

// payload.push(record);

//  });

//  await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/permissions/save",{
//   method:"POST",
//   headers:{ "Content-Type":"application/json" },
//   body:JSON.stringify({
//    employee_id:selectedEmployee,
//    permissions:payload
//   })
//  });

//  alert("Permissions Saved");

// };



const savePermissions = async () => {
  if (!selectedEmployee) return alert("Please select an employee first");

  const payload = [];

  // 1. Loop through the screens of selected modules
  screens
    .filter(screen => selectedModules.includes(screen.module))
    .forEach(screen => {
      
      // 2. Prepare the values for this specific screen
      const p = {
        can_add: permissions[`${screen.id}_add`] ? 1 : 0,
        can_edit: permissions[`${screen.id}_edit`] ? 1 : 0,
        can_view: permissions[`${screen.id}_view`] ? 1 : 0,
        can_refresh: permissions[`${screen.id}_refresh`] ? 1 : 0,
        can_save: permissions[`${screen.id}_save`] ? 1 : 0,
        can_approve: permissions[`${screen.id}_approve`] ? 1 : 0,
        can_print: permissions[`${screen.id}_print`] ? 1 : 0,
        can_exit: permissions[`${screen.id}_exit`] ? 1 : 0
      };

      // 3. 🔥 THE FIX: Check if ANY of these values are 1
      const hasValue = Object.values(p).some(val => val === 1);

      // 4. Only push to payload if at least one checkbox was checked
      if (hasValue) {
        payload.push({
          screen_id: screen.id,
          ...p
        });
      }
    });

  // 5. If no checkboxes were selected across all screens, stop here
  if (payload.length === 0) {
    return alert("No permissions selected. Please check at least one box.");
  }

  // 6. Send only the active permissions to the backend
  try {
    const response = await fetch("https://hmsapi.emedhatechnologies.com/master/api/api/permissions/save", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        employee_id: selectedEmployee,
        permissions: payload
      })
    });

    if (response.ok) {
      alert("Permissions Saved Successfully");
    } else {
      alert("Failed to save permissions");
    }
  } catch (error) {
    console.error("Save error:", error);
    alert("Network error while saving");
  }
};

const filteredScreens = screens.filter(screen =>
 selectedModules.includes(screen.module)
);

const grouped = {};

filteredScreens.forEach(screen=>{

 if(!grouped[screen.module]) grouped[screen.module] = {};

 if(!grouped[screen.module][screen.type]) grouped[screen.module][screen.type] = [];

 grouped[screen.module][screen.type].push(screen);

});

return(

<div className="permission-container">

<div className="permission-header">

<h2>Employee Permission Management</h2>

<div className="filters">

<label>Employee</label>

<select
value={selectedEmployee}
onChange={(e)=>setSelectedEmployee(e.target.value)}
>
<option value="">Select Employee</option>

{employees.map(emp=>(
<option key={emp.id} value={emp.id}>
{emp.name}
</option>
))}

</select>

</div>

</div>

<div className="module-select">

<h3>Select Modules</h3>

{modules.map(mod=>(
<label key={mod.id} className="module-checkbox">

<input
type="checkbox"
value={mod.module_name}
checked={selectedModules.includes(mod.module_name)}
onChange={handleModuleSelect}
/>

{mod.module_name}

</label>
))}

</div>

<div className="permission-table">

<table>

<thead>

<tr>

<th>Screen</th>

{actions.map(action=>(
<th key={action}>{action.toUpperCase()}</th>
))}

</tr>

</thead>

<tbody>

{Object.keys(grouped).map(module=>(

<React.Fragment key={module}>

<tr className="module-row">
<td colSpan="9">{module}</td>
</tr>

{Object.keys(grouped[module]).map(type=>(

<React.Fragment key={type}>

<tr className="type-row">
<td colSpan="9">{type}</td>
</tr>

{grouped[module][type].map(screen=>(

<tr key={screen.id}>

<td className="screen-name">
{screen.name}
</td>

{actions.map(action=>{

const key = `${screen.id}_${action}`;

return(
<td key={action}>

<input
type="checkbox"
checked={permissions[key] || false}
onChange={()=>togglePermission(screen.id,action)}
/>

</td>
);

})}

</tr>

))}

</React.Fragment>

))}

</React.Fragment>

))}

</tbody>

</table>

</div>

<div className="save-area">

<button
className="save-btn"
onClick={savePermissions}
>
Save Permissions
</button>

</div>

</div>

);

}